import React from 'react';
import { ProfileImageView } from 'src/app/components';

type CoverPageProps = {
  childName: string;
  date?: string;
  profilePicture?: string;
  nurseryLogo?: string;
  nurseryName: string;
};

const CoverPage: React.FC<CoverPageProps> = ({ childName, date, profilePicture, nurseryLogo, nurseryName }) => {
  return (
    <div className='cover-page-container d-flex flex-column align-items-center justify-content-center'>
      <ProfileImageView
        imageUrl={nurseryLogo}
        resizeMode={'contain'}
        name={nurseryName}
        customAvatarStyles={'text-gray-100 font-40'}
        customContainerStyles={'cover-nursery-img mg-b-100'}
      />
      <div className='cover-nursery-name text-center'>My Learning Journey</div>
      <ProfileImageView
        imageUrl={profilePicture}
        resizeMode={'cover'}
        name={childName}
        customAvatarStyles={'text-gray-100 font-40'}
        customContainerStyles={'cover-nursery-profile-img'}
      />
      <div className='cover-nursery-profile-name'>{childName}</div>
      <p className='cover-nursery-date'>{date}</p>
    </div>
  );
};

export default CoverPage;
